// src/config/axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// Inyectar automáticamente el token si existe
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("tokenNovianCore");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default axiosInstance;